import pizza from "../../images/pizza.jpg";
import hamburguer from "../../images/hamburguer.jpg";
import sandwich from "../../images/sandwich.jpg";

export const productData = [
    {
        image: pizza,
        alt: "Pizza",
        name: "Supreme Pizza",
        desc: "Marinara sauce, basil, italian sausage, roma, tomatoes, olives and pesto",
        price: "$19.99",
    },
    {
        image: hamburguer,
        alt: "Pizza",
        name: "Hamburguer",
        desc: "Marinara sauce, basil, italian sausage, roma, tomatoes, olives and pesto",
        price: "$19.99",
    },
    {
        image: sandwich,
        alt: "Pizza",
        name: "Supreme Sandwich",
        desc: "Marinara sauce, basil, italian sausage, roma, tomatoes, olives and pesto",
        price: "$19.99",
    },
];
